import { combineReducers } from '@reduxjs/toolkit';
import auth from '@ameroservices-platform/loppe-boothownerui/app/auth/store';
import fuse from './fuse';
import i18n from './i18nSlice';
import shared from './shared';
import global from '../main/apps/globalStore';
import booth from '../main/apps/booth/boothStore';

const createReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		auth,
		fuse,
		i18n,
		shared,
		global,
		booth,
		...asyncReducers,
	});

	/*
	Reset the redux store when user logged out
	 */
	if (action.type === 'auth/user/userLoggedOut') {
		// state = undefined;
	}

	return combinedReducer(state, action);
};

export default createReducer;
